import axios from './axios'

export const getConfig = (brand = undefined) => {
    let query = ""
    if (brand) {
        query = `?brand=${brand}`
    }
    return axios.get(`/implantations/client${query}`)
}


// WEBPACK FOOTER //
// ./src/requesters/implantations.js